export const PermissaoComunidadeEnum = {
	GERENCIAR_COMUNIDADE: "GERENCIAR_COMUNIDADE",
};

export const PermissaoGamificacaoEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_GAMIFICACAO",
	EDITAR_CONFIGURACAO: "EDITAR_CONFIGURACAO_GAMIFICACAO",
	VISUALIZAR_RANKING: "VISUALIZAR_RANKING_GAMIFICACAO",
	VISUALIZAR_HISTORICO_ALUNO: "VISUALIZAR_HISTORICO_ALUNO_GAMIFICACAO",
	ATRIBUIR_PONTOS_MANUAL: "ATRIBUIR_PONTOS_MANUAL_GAMIFICACAO",
};

export const PermissaoCompeticaoEnum = {
	VISUALIZAR: "VISUALIZAR_COMPETICAO",
	CRIAR: "CRIAR_COMPETICAO",
	EXCLUIR: "EXCLUIR_COMPETICAO",
};

export const PermissaoUsuarioEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_USUARIO",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_USUARIO",
	VISUALIZAR_ALUNOS: "VISUALIZAR_ALUNOS_USUARIO",
	VISUALIZAR_TELA_ALUNOS: "VISUALIZAR_TELA_ALUNOS",
	CRIAR: "CRIAR_USUARIO",
	EXCLUIR: "EXCLUIR_USUARIO",
};

export const PermissaoGrupoUsuarioEnum = {
	VISUALIZAR: "VISUALIZAR_GRUPO_USUARIO",
	CRIAR: "CRIAR_GRUPO_USUARIO",
	EXCLUIR: "EXCLUIR_GRUPO_USUARIO",
};

export const PermissaoAlimentoEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_ALIMENTO",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_ALIMENTO",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_ALIMENTO",
	CRIAR: "CRIAR_ALIMENTO",
	EXCLUIR: "EXCLUIR_ALIMENTO",
};

export const PermissaoFichaDietaEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_FICHA_DIETA",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_FICHA_DIETA",
	VISUALIZAR_ALUNOS: "VISUALIZAR_ALUNOS_FICHA_DIETA",
	VISUALIZAR_PROPRIAS: "VISUALIZAR_PROPRIAS_FICHA_DIETA",
	CRIAR: "CRIAR_FICHA_DIETA",
	EXCLUIR: "EXCLUIR_FICHA_DIETA",
};

export const PermissaoObservacaoDietaEnum = {
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_OBSERVACAO_DIETA",
	VISUALIZAR_ALUNOS: "VISUALIZAR_ALUNOS_OBSERVACAO_DIETA",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_OBSERVACAO_DIETA",
	CRIAR: "CRIAR_OBSERVACAO_DIETA",
	EXCLUIR: "EXCLUIR_OBSERVACAO_DIETA",
};

export const PermissaoTecnicaExercicioEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_TECNICA_EXERCICIO",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_TECNICA_EXERCICIO",
	CRIAR: "CRIAR_TECNICA_EXERCICIO",
	EXCLUIR: "EXCLUIR_TECNICA_EXERCICIO",
};

export const PermissaoExercicioEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_EXERCICIO",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_EXERCICIO",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_EXERCICIO",
	VISUALIZAR_SUAS_FICHAS: "VISUALIZAR_SUAS_FICHAS_EXERCICIO",
	CRIAR: "CRIAR_EXERCICIO",
	EXCLUIR: "EXCLUIR_EXERCICIO",
};

export const PermissaoFichaTreinoEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_FICHA_TREINO",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_FICHA_TREINO",
	VISUALIZAR_ALUNOS: "VISUALIZAR_ALUNOS_FICHA_TREINO",
	VISUALIZAR_PROPRIAS: "VISUALIZAR_PROPRIAS_FICHA_TREINO",
	CRIAR: "CRIAR_FICHA_TREINO",
	EXCLUIR: "EXCLUIR_FICHA_TREINO",
};

export const PermissaoExecucaoTreinoEnum = {
	VISUALIZAR: "VISUALIZAR_EXECUCAO_TREINO",
	CRIAR: "CRIAR_EXECUCAO_TREINO",
	EXCLUIR: "EXCLUIR_EXECUCAO_TREINO",
};

export const PermissaoObservacoesGeraisEnum = {
	VISUALIZAR: "VISUALIZAR_OBSERVACOES_GERAIS",
	CRIAR: "CRIAR_OBSERVACOES_GERAIS",
	EXCLUIR: "EXCLUIR_OBSERVACOES_GERAIS",
};

export const PermissaoRepeticoesFrequenteEnum = {
	VISUALIZAR: "VISUALIZAR_REPETICOES_FREQUENTE",
	CRIAR: "CRIAR_REPETICOES_FREQUENTE",
	EXCLUIR: "EXCLUIR_REPETICOES_FREQUENTE",
};

export const PermissaoTabelaSubstituicaoEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_TABELA_SUBSTITUICAO",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_TABELA_SUBSTITUICAO",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_TABELA_SUBSTITUICAO",
	CRIAR: "CRIAR_TABELA_SUBSTITUICAO",
	EXCLUIR: "EXCLUIR_TABELA_SUBSTITUICAO",
};

export const PermissaoRefeicaoEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_REFEICAO",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_REFEICAO",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_REFEICAO",
	CRIAR: "CRIAR_REFEICAO",
	EDITAR: "EDITAR_REFEICAO",
	EXCLUIR: "EXCLUIR_REFEICAO",
	LISTAR: "REFEICAO_LISTAR",
	VER: "REFEICAO_VER",
};

export const PermissaoQuestionarioDinamicoEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_QUESTIONARIO_DINAMICO",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_QUESTIONARIO_DINAMICO",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_QUESTIONARIO_DINAMICO",
	CRIAR: "CRIAR_QUESTIONARIO_DINAMICO",
	EXCLUIR: "EXCLUIR_QUESTIONARIO_DINAMICO",
};

export const PermissaoConfiguracaoAppEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_CONFIGURACAO_APP",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_CONFIGURACAO_APP",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_CONFIGURACAO_APP",
	VISUALIZAR_SEUS_PROFISSIONAIS:
		"VISUALIZAR_SEUS_PROFISSIONAIS_CONFIGURACAO_APP",
	CRIAR: "CRIAR_CONFIGURACAO_APP",
	EDITAR: "EDITAR_CONFIGURACAO_APP",
	EXCLUIR: "EXCLUIR_CONFIGURACAO_APP",
};

export const PermissaoCupomEnum = {
	VISUALIZAR: "VISUALIZAR_CUPOM",
	CRIAR: "CRIAR_CUPOM",
	EXCLUIR: "EXCLUIR_CUPOM",
};

export const PermissaoPlanoContratualEnum = {
	VISUALIZAR: "VISUALIZAR_PLANO_CONTRATUAL",
	CRIAR: "CRIAR_PLANO_CONTRATUAL",
	EXCLUIR: "EXCLUIR_PLANO_CONTRATUAL",
};

export const PermissaoGrupamentoMuscularEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_GRUPAMENTO_MUSCULAR",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_GRUPAMENTO_MUSCULAR",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_GRUPAMENTO_MUSCULAR",
	CRIAR: "CRIAR_GRUPAMENTO_MUSCULAR",
	EXCLUIR: "EXCLUIR_GRUPAMENTO_MUSCULAR",
};

export const PermissaoTreinoPrecadastradoEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_TREINO_PRECADASTRADO",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_TREINO_PRECADASTRADO",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_TREINO_PRECADASTRADO",
	CRIAR: "CRIAR_TREINO_PRECADASTRADO",
	EDITAR: "EDITAR_TREINO_PRECADASTRADO",
	EXCLUIR: "EXCLUIR_TREINO_PRECADASTRADO",
};

export const PermissaoMaterialEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_MATERIAL",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_MATERIAL",
	VISUALIZAR_ALUNOS: "VISUALIZAR_ALUNOS_MATERIAL",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_MATERIAL",
	CRIAR: "CRIAR_MATERIAL",
	EXCLUIR: "EXCLUIR_MATERIAL",
};

export const PermissaoFichaDietaPrecadastradaEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_FICHA_DIETA_PRECADASTRADA",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_FICHA_DIETA_PRECADASTRADA",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_FICHA_DIETA_PRECADASTRADA",
	CRIAR: "CRIAR_FICHA_DIETA_PRECADASTRADA",
	EDITAR: "EDITAR_FICHA_DIETA_PRECADASTRADA",
	EXCLUIR: "EXCLUIR_FICHA_DIETA_PRECADASTRADA",
};

export const PermissaoFuncionarioEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_FUNCIONARIO",
	VISUALIZAR: "VISUALIZAR_FUNCIONARIO",
	CRIAR: "CRIAR_FUNCIONARIO",
	EDITAR: "EDITAR_FUNCIONARIO",
	EXCLUIR: "EXCLUIR_FUNCIONARIO",
};

export const PermissaoGrupoFuncionarioEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_GRUPO_FUNCIONARIO",
	VISUALIZAR: "VISUALIZAR_GRUPO_FUNCIONARIO",
	CRIAR: "CRIAR_GRUPO_FUNCIONARIO",
	EDITAR: "EDITAR_GRUPO_FUNCIONARIO",
	EXCLUIR: "EXCLUIR_GRUPO_FUNCIONARIO",
};

export const PermissaoIntervalosFrequenteEnum = {
	VISUALIZAR: "VISUALIZAR_INTERVALOS_FREQUENTE",
	CRIAR: "CRIAR_INTERVALOS_FREQUENTE",
	EXCLUIR: "EXCLUIR_INTERVALOS_FREQUENTE",
};

export const PermissaoNomesTreinoFrequenteEnum = {
	VISUALIZAR: "VISUALIZAR_NOMES_TREINO_FREQUENTE",
	CRIAR: "CRIAR_NOMES_TREINO_FREQUENTE",
	EXCLUIR: "EXCLUIR_NOMES_TREINO_FREQUENTE",
};

export const PermissaoAtualizacaoFotosEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_ATUALIZACAO_FOTOS",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_ATUALIZACAO_FOTOS",
	VISUALIZAR_ALUNOS: "VISUALIZAR_ALUNOS_ATUALIZACAO_FOTOS",
	VISUALIZAR_PROPRIAS: "VISUALIZAR_PROPRIAS_ATUALIZACAO_FOTOS",
	CRIAR: "CRIAR_ATUALIZACAO_FOTOS",
	EXCLUIR: "EXCLUIR_ATUALIZACAO_FOTOS",
};

export const PermissaoComparacaoImagensEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_COMPARACAO_IMAGENS",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_COMPARACAO_IMAGENS",
	VISUALIZAR_ALUNOS: "VISUALIZAR_ALUNOS_COMPARACAO_IMAGENS",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_COMPARACAO_IMAGENS",
	CRIAR: "CRIAR_COMPARACAO_IMAGENS",
	EXCLUIR: "EXCLUIR_COMPARACAO_IMAGENS",
};

export const PermissaoRespostaQuestionarioDinamicoEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_RESPOSTA_QUESTIONARIO_DINAMICO",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_RESPOSTA_QUESTIONARIO_DINAMICO",
	VISUALIZAR_ALUNOS: "VISUALIZAR_ALUNOS_RESPOSTA_QUESTIONARIO_DINAMICO",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_RESPOSTA_QUESTIONARIO_DINAMICO",
	CRIAR: "CRIAR_RESPOSTA_QUESTIONARIO_DINAMICO",
	EXCLUIR: "EXCLUIR_RESPOSTA_QUESTIONARIO_DINAMICO",
};

export const PermissaoRefeicaoConcluidaEnum = {
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_REFEICAO_CONCLUIDA",
	VISUALIZAR_ALUNOS: "VISUALIZAR_ALUNOS_REFEICAO_CONCLUIDA",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_REFEICAO_CONCLUIDA",
	CRIAR: "CRIAR_REFEICAO_CONCLUIDA",
	EXCLUIR: "EXCLUIR_REFEICAO_CONCLUIDA",
};

export const PermissaoLogsEnum = {
	VISUALIZAR_AUDIT_LOGS: "VISUALIZAR_AUDIT_LOGS",
	VISUALIZAR_ACTIVITY_LOGS: "VISUALIZAR_ACTIVITY_LOGS",
	VISUALIZAR_LOGS_FUNCIONARIOS: "VISUALIZAR_LOGS_FUNCIONARIOS",
	EXPORTAR_LOGS: "EXPORTAR_LOGS",
};

export const PermissaoInformacoesAlunoEnum = {
	VISUALIZAR: "VISUALIZAR_INFORMACOES_ALUNO",
	CRIAR: "CRIAR_INFORMACOES_ALUNO",
	EXCLUIR: "EXCLUIR_INFORMACOES_ALUNO",
};

export const PermissaoDashboardAdminEnum = {
	VISUALIZAR: "VISUALIZAR_DASHBOARD_ADMIN",
};

export const PermissaoLogErroAppEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_LOG_ERRO_APP",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_LOG_ERRO_APP",
	EXCLUIR: "EXCLUIR_LOG_ERRO_APP",
};

export const PermissaoNotificacaoPersonalizadaEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_NOTIFICACAO_PERSONALIZADA",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_NOTIFICACAO_PERSONALIZADA",
	CRIAR: "CRIAR_NOTIFICACAO_PERSONALIZADA",
};

export const PermissaoCardioEnum = {
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_CARDIO",
	VISUALIZAR_ALUNOS: "VISUALIZAR_ALUNOS_CARDIO",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_CARDIO",
	CRIAR: "CRIAR_CARDIO",
	EXCLUIR: "EXCLUIR_CARDIO",
};

export const PermissaoAnexoAlunoEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_ANEXO_ALUNO",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_ANEXO_ALUNO",
	VISUALIZAR_ALUNOS: "VISUALIZAR_ALUNOS_ANEXO_ALUNO",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_ANEXO_ALUNO",
	CRIAR: "CRIAR_ANEXO_ALUNO",
	EXCLUIR: "EXCLUIR_ANEXO_ALUNO",
};

export const PermissaoNomesRefeicaoFrequenteEnum = {
	VISUALIZAR: "VISUALIZAR_NOMES_REFEICAO_FREQUENTE",
	CRIAR: "CRIAR_NOMES_REFEICAO_FREQUENTE",
	EXCLUIR: "EXCLUIR_NOMES_REFEICAO_FREQUENTE",
};

export const PermissaoHorariosRefeicaoFrequenteEnum = {
	VISUALIZAR: "VISUALIZAR_HORARIOS_REFEICAO_FREQUENTE",
	CRIAR: "CRIAR_HORARIOS_REFEICAO_FREQUENTE",
	EXCLUIR: "EXCLUIR_HORARIOS_REFEICAO_FREQUENTE",
};

export const PermissaoModuloEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_MODULO",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_MODULO",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_MODULO",
	VISUALIZAR_ALUNO: "VISUALIZAR_ALUNO_MODULO",
	CRIAR: "CRIAR_MODULO",
	EDITAR: "EDITAR_MODULO",
	EXCLUIR: "EXCLUIR_MODULO",
	GERENCIAR_ACESSOS: "GERENCIAR_ACESSOS_MODULO",
};

export const PermissaoAulaEnum = {
	CRIAR: "CRIAR_AULA",
	EDITAR: "EDITAR_AULA",
	EXCLUIR: "EXCLUIR_AULA",
};

export const PermissaoComentarioAulaEnum = {
	CRIAR: "CRIAR_COMENTARIO_AULA",
	EXCLUIR_PROPRIO: "EXCLUIR_PROPRIO_COMENTARIO_AULA",
	EXCLUIR_TODOS: "EXCLUIR_TODOS_COMENTARIO_AULA",
};
export const PermissaoPlanoProfissionalEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_PLANO_PROFISSIONAL",
	VISUALIZAR: "VISUALIZAR_PLANO_PROFISSIONAL",
	CRIAR: "CRIAR_PLANO_PROFISSIONAL",
	EXCLUIR: "EXCLUIR_PLANO_PROFISSIONAL",
};

export const PermissaoConfiguracaoExercicioFrequenteEnum = {
	VISUALIZAR: "VISUALIZAR_CONFIGURACAO_EXERCICIO_FREQUENTE",
	CRIAR: "CRIAR_CONFIGURACAO_EXERCICIO_FREQUENTE",
	EXCLUIR: "EXCLUIR_CONFIGURACAO_EXERCICIO_FREQUENTE",
};

export const PermissaoFinanceiroEnum = {
	VISUALIZAR_DASHBOARD_FINANCEIRO: "VISUALIZAR_DASHBOARD_FINANCEIRO",
	EDITAR_PLANO_ALUNO: "EDITAR_PLANO_ALUNO",
	GERENCIAR_COBRANCAS: "GERENCIAR_COBRANCAS",
};

export const PermissaoChatEnum = {
	VISUALIZAR_CHAT: "VISUALIZAR_CHAT",
	ENVIAR_MENSAGEM_CHAT: "ENVIAR_MENSAGEM_CHAT",
};

export const PermissaoCrmEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_CRM",
	VISUALIZAR_TODOS: "VISUALIZAR_TODOS_CRM",
	VISUALIZAR_PROPRIOS: "VISUALIZAR_PROPRIOS_CRM",
	CRIAR_LEAD: "CRIAR_LEAD_CRM",
	EDITAR_LEAD: "EDITAR_LEAD_CRM",
	EXCLUIR_LEAD: "EXCLUIR_LEAD_CRM",
	GERENCIAR_COLUNAS: "GERENCIAR_COLUNAS_CRM",
	GERENCIAR_TAGS: "GERENCIAR_TAGS_CRM",
	GERENCIAR_COMISSOES: "GERENCIAR_COMISSOES_CRM",
	VISUALIZAR_COMISSOES: "VISUALIZAR_COMISSOES_CRM",
};

export const PermissaoTagAlunoEnum = {
	VISUALIZAR: "VISUALIZAR_TAG_ALUNO",
	CRIAR: "CRIAR_TAG_ALUNO",
	EXCLUIR: "EXCLUIR_TAG_ALUNO",
};
